// extracted by mini-css-extract-plugin
export var avatarContainer = "_g3-0";
export var avatarTypingWave = "_g3-i";
export var gray = "_g3-f";
export var green = "_g3-c";
export var icon = "_g3-9";
export var image = "_g3-1";
export var lg = "_g3-6";
export var md = "_g3-5";
export var presenceDot = "_g3-b";
export var red = "_g3-d";
export var sm = "_g3-4";
export var status = "_g3-a";
export var typingDot = "_g3-h";
export var typingPill = "_g3-g";
export var xl = "_g3-7";
export var xs = "_g3-3";
export var xxl = "_g3-8";
export var xxs = "_g3-2";
export var yellow = "_g3-e";